"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.archivedPlans = exports.plansUSD = exports.plansRUB = void 0;
const enums_1 = require("./enums");
exports.plansRUB = [
    {
        name: enums_1.PlanNames.free,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 0,
            [enums_1.PaymentPeriods.ANNUAL]: 0,
        },
        currency: enums_1.Currencies.RUB,
        coursesCount: 0,
        isArchived: false,
    },
    {
        name: enums_1.PlanNames.pro1,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 119000,
            [enums_1.PaymentPeriods.ANNUAL]: 94800,
        },
        currency: enums_1.Currencies.RUB,
        coursesCount: 1,
        isArchived: false,
    },
    {
        name: enums_1.PlanNames.pro5,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 359000,
            [enums_1.PaymentPeriods.ANNUAL]: 287500,
        },
        currency: enums_1.Currencies.RUB,
        coursesCount: 5,
        isArchived: false,
    },
    {
        name: enums_1.PlanNames.pro10,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 599000,
            [enums_1.PaymentPeriods.ANNUAL]: 479100,
        },
        currency: enums_1.Currencies.RUB,
        coursesCount: 10,
        isArchived: false,
    },
    {
        name: enums_1.PlanNames.guru,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 1680000,
            [enums_1.PaymentPeriods.ANNUAL]: 1320000,
        },
        currency: enums_1.Currencies.RUB,
        coursesCount: Number.MAX_SAFE_INTEGER,
        isArchived: false,
    },
];
exports.plansUSD = [
    {
        name: enums_1.PlanNames.free,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 0,
            [enums_1.PaymentPeriods.ANNUAL]: 0,
        },
        currency: enums_1.Currencies.USD,
        coursesCount: 0,
        isArchived: false,
    },
    {
        name: enums_1.PlanNames.pro1,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 1499,
            [enums_1.PaymentPeriods.ANNUAL]: 1199,
        },
        currency: enums_1.Currencies.USD,
        coursesCount: 1,
        isArchived: false,
    },
    {
        name: enums_1.PlanNames.pro5,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 4999,
            [enums_1.PaymentPeriods.ANNUAL]: 3999,
        },
        currency: enums_1.Currencies.USD,
        coursesCount: 5,
        isArchived: false,
    },
    {
        name: enums_1.PlanNames.pro10,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 6999,
            [enums_1.PaymentPeriods.ANNUAL]: 5599,
        },
        currency: enums_1.Currencies.USD,
        coursesCount: 10,
        isArchived: false,
    },
    {
        name: enums_1.PlanNames.guru,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 199,
            [enums_1.PaymentPeriods.ANNUAL]: 159,
        },
        currency: enums_1.Currencies.USD,
        coursesCount: Number.MAX_SAFE_INTEGER,
        isArchived: false,
    },
];
exports.archivedPlans = [
    {
        name: enums_1.ArchivedPlanNames["#1"],
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 99000,
            [enums_1.PaymentPeriods.ANNUAL]: 99000,
        },
        currency: enums_1.Currencies.RUB,
        coursesCount: 1,
        isArchived: true,
    },
    {
        name: enums_1.ArchivedPlanNames["#3"],
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 280000,
            [enums_1.PaymentPeriods.ANNUAL]: 280000,
        },
        currency: enums_1.Currencies.RUB,
        coursesCount: 3,
        isArchived: true,
    },
    {
        name: enums_1.ArchivedPlanNames["#7"],
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 595000,
            [enums_1.PaymentPeriods.ANNUAL]: 595000,
        },
        currency: enums_1.Currencies.RUB,
        coursesCount: 7,
        isArchived: true,
    },
    {
        name: enums_1.ArchivedPlanNames["#10"],
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 790000,
            [enums_1.PaymentPeriods.ANNUAL]: 790000,
        },
        currency: enums_1.Currencies.RUB,
        coursesCount: 10,
        isArchived: true,
    },
];
//# sourceMappingURL=plans.js.map